import { makeAutoObservable } from "mobx";
import { Subject } from "rxjs";
import {
  IAPIPaginationResponse,
  PaginationModel,
} from "@mindmemobile/mm-shared-global";
import {
  FundingDetailPageModel,
  FundingPayoutsGridModel,
  FundingSummaryDetailModel,
} from "../models/FundingPayoutsModel";
import {
  IAPIFundingDetailPageResponseModel,
  IAPIFundingMerchantDataResponseModel,
  IAPIFundingPayoutsGridModel,
  IAPIFundingSummaryResponseModel,
} from "../interfaces/IAPIFundingPayoutsModel";

export default class FundingStore {
  public searchValue: string = "";
  public gridData: FundingPayoutsGridModel[] = [];
  public pagination: PaginationModel = new PaginationModel({
    pageNumber: 1,
    pageSize: 10,
  });
  public searchSubject = new Subject<boolean>();
  public detailPage: FundingDetailPageModel = new FundingDetailPageModel();
  public merchantAccounts: FundingSummaryDetailModel[] = [];
  public payouts: FundingPayoutsGridModel[] = [];
  public showFilter: boolean = false;
  constructor() {
    makeAutoObservable(this);
  }

  deserializeSummaryPageAPIResponse(
    data: IAPIFundingSummaryResponseModel
  ): void {
    this.payouts =
      data?.payouts?.map((payout: IAPIFundingPayoutsGridModel) => {
        return FundingPayoutsGridModel.deserializeAPIModel(payout);
      }) || [];
    this.merchantAccounts =
      data?.merchantAccounts?.map(
        (merchantAccount: IAPIFundingMerchantDataResponseModel) => {
          return FundingSummaryDetailModel.deserializeAPIModel(merchantAccount);
        }
      ) || [];
  }

  deserializePayoutAPIResponse(
    data: IAPIFundingPayoutsGridModel[],
    pagination: IAPIPaginationResponse
  ): void {
    this.gridData =
      data?.map((payout: IAPIFundingPayoutsGridModel) => {
        return FundingPayoutsGridModel.deserializeAPIModel(payout);
      }) || [];
    this.pagination = PaginationModel.deserialize(pagination);
  }

  deserializeDetailPageAPIResponse(
    data: IAPIFundingDetailPageResponseModel
  ): void {
    this.detailPage = FundingDetailPageModel.deserializeAPIModel(data);
  }

  updateSearchValue(value: string): void {
    this.searchValue = value;
    this.searchSubject.next(true);
  }

  toggleFilter(): void {
    this.showFilter = !this.showFilter;
  }

  filterPayouts(status: string[], isEqual = true): FundingPayoutsGridModel[] {
    return this.payouts.filter((payout) =>
      isEqual
        ? status.indexOf(payout.status) > -1
        : status.indexOf(payout.status) === -1
    );
  }
}
